import { Listbox, Transition } from "@headlessui/react";
import { CheckCircleIcon, CheckIcon, ChevronUpDownIcon, HomeIcon } from "@heroicons/react/24/solid";
import { Fragment, useState } from "react";
import SelectMenu from "../../../components/SelectMenu";
import { useNavigate } from "react-router-dom";

const pages = [
    { name: "관리자 관리", href: "/ad/admin", current: false },
    { name: "관리자 신규 등록", href: "/addUser", current: true },
];

const ranks = [{ name: "대표이사" }, { name: "총판장" }, { name: "지사장" }, { name: "대리점장" }];

export default function AddAdmin() {
    const navigate = useNavigate();

    const [selected, setSelected] = useState(ranks[0]);

    return (
        <div>
            <nav className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 max-w-full" aria-label="Breadcrumb">
                <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
                    <li className="flex">
                        <div className="flex items-center">
                            <a href="/" className="text-gray-400 hover:text-gray-500">
                                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {pages.map((page) => (
                        <li key={page.name} className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <a
                                    href={page.href}
                                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    aria-current={page.current ? "page" : undefined}
                                >
                                    {page.name}
                                </a>
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
            <div className="isolate bg-white px-6 py-24 sm:py-10 lg:px-8 max-w-full">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mt-10">관리자 신규 등록</h2>
                </div>
                <form action="#" method="POST" className="mx-auto max-w-xl sm:mt-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                        <div>
                            <label htmlFor="userId" className="block text-sm font-semibold leading-6 text-gray-900">
                                아이디
                            </label>
                            <div className="flex justify-between">
                                <div className="mt-2">
                                    <input
                                        type="text"
                                        name="userId"
                                        id="userId"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                    />
                                </div>
                                <div className="mt-2">
                                    <button
                                        type="button"
                                        className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                    >
                                        중복확인
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-semibold leading-6 text-gray-900">
                                비밀번호
                            </label>
                            <div className="mt-2">
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userName" className="block text-sm font-semibold leading-6 text-gray-900">
                                이름
                            </label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="userName"
                                    id="userName"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="phoneNm" className="block text-sm font-semibold leading-6 text-gray-900">
                                휴대전화 번호
                            </label>
                            <div className="mt-2">
                                <input
                                    type="tel"
                                    name="phoneNm"
                                    id="phoneNm"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="userMail" className="block text-sm font-semibold leading-6 text-gray-900">
                                이메일
                            </label>
                            <div className="mt-2">
                                <input
                                    type="email"
                                    name="userMail"
                                    id="userMail"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-semibold leading-6 text-gray-900">생년월일</label>
                            <div className="mt-2">
                                <input
                                    type="date"
                                    name="birthDate"
                                    id="birthDate"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div>
                            <SelectMenu labelText={"직급"} options={ranks} onSelect={setSelected} selectedId={selected.name} />
                        </div>
                        <div>
                            <label htmlFor="addr" className="block text-sm font-semibold leading-6 text-gray-900">
                                사업장 주소
                            </label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="addr"
                                    id="addr"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                />
                                <input
                                    type="text"
                                    name="detailAddr"
                                    id="detailAddr"
                                    className="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mt-10 flex justify-center">
                        <div className="mr-3">
                            <button
                                type="button"
                                className="inline-flex items-center gap-x-1.5 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                <CheckCircleIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                등록
                            </button>
                        </div>
                        <div>
                            <button
                                type="button"
                                className="rounded-md bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-100"
                                onClick={() => navigate("/ad/admin")}
                            >
                                목록
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
